import { useUserEventLogger } from '@repo/tracking-service';
import { useDialog } from '@repo/ui';
import { TopNavigation } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

export const SurveyTopNavigation = ({
  leftIcon = 'back',
  needConfirm = true,
  onBackClick,
  rightButton,
  leftClickEvent
}: {
  leftIcon?: 'back';
  needConfirm?: boolean;
  onBackClick?: () => void;
  rightButton?: { onClick: () => void; label: string };
  leftClickEvent?: string;
}) => {
  const router = useRouter();
  const { showDialog } = useDialog();
  const { sendClickEvent } = useUserEventLogger();

  const handleGoBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      router.back();
    }
  };

  return (
    <>
      <TopNavigation.Basic
        leftIcon={leftIcon}
        className={'z-10 mx-auto max-w-[1080px] bg-white'}
        onLeftClick={() => {
          if (leftClickEvent) {
            sendClickEvent(leftClickEvent);
          }
          if (needConfirm) {
            showDialog({
              title: '저장하지 않고 나갈까요?',
              description: '이대로 나가면 바꾼 정보는 저장되지 않아요.',
              buttons: {
                secondary: {
                  text: '아니요'
                },
                primary: {
                  text: '예',
                  onClick: handleGoBack
                }
              }
            });
            return;
          }
          handleGoBack();
        }}
        rightTextButton={rightButton ? { onClick: rightButton.onClick, label: rightButton.label, state: 'gray' } : undefined}
      />
    </>
  );
};
